export default __webpack_public_path__ + "static/media/map.8ffe5ab1.svg";